import Vue from 'vue';
import Vuex from 'vuex';

import { FeathersVuex } from '../plugins/feathers-client';
import logger from './plugins/logger';

import { state, mutations, actions, getters } from './root';
import authentication from './authentication';
import usersService from './users';
import actionsService from './actions';
import commentsService from './comments';
import feedbacksService from './feedbacks';
import likesService from './likes';
import searchService from './search';


Vue.use(Vuex);
Vue.use(FeathersVuex);


const store = new Vuex.Store({
	state,
	getters,
	mutations,
	actions,
	plugins: [
		// plugins
		logger,

		// services
		usersService,
		authentication,
		actionsService,
		commentsService,
		feedbacksService,
		likesService,
		searchService,
	],
});

export default store;